// extracted by mini-css-extract-plugin
module.exports = {"container":"nav-tab-bar_container__2VFaW","link":"nav-tab-bar_link__1xnuq","active":"nav-tab-bar_active__1Vuu7"};